(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["de-faq"] && !Shopify.designMode) return;
  try {
    
  // Animate the <details> height open/closed instead of the native snap.
  (function () {
    var DURATION = 320;
    var EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function setupItem(details) {
      if (details.dataset.deFaqReady === 'true') return;
      details.dataset.deFaqReady = 'true';

      var summary = details.querySelector('.de-faq__q');
      var answer = details.querySelector('.de-faq__a');
      if (!summary || !answer) return;

      // Colours follow this class, not [open], so they can transition while the
      // height animates. Sync it with any block that starts open.
      details.classList.toggle('is-open', details.open);

      var animation = null;
      var isClosing = false;
      var isExpanding = false;

      function onFinish(open) {
        details.open = open;
        animation = null;
        isClosing = false;
        isExpanding = false;
        details.style.height = '';
        details.style.overflow = '';
      }

      function animateHeight(start, end, open) {
        if (animation) animation.cancel();
        animation = details.animate(
          { height: [start + 'px', end + 'px'] },
          { duration: DURATION, easing: EASING }
        );
        animation.onfinish = function () { onFinish(open); };
        animation.oncancel = function () { isClosing = false; isExpanding = false; };
      }

      function expand() {
        isExpanding = true;
        animateHeight(details.offsetHeight, summary.offsetHeight + answer.offsetHeight, true);
      }

      function open() {
        details.style.height = details.offsetHeight + 'px';
        details.open = true;
        details.classList.add('is-open');
        window.requestAnimationFrame(expand);
      }

      function shrink() {
        isClosing = true;
        details.classList.remove('is-open');
        animateHeight(details.offsetHeight, summary.offsetHeight, false);
      }

      summary.addEventListener('click', function (event) {
        event.preventDefault();

        if (reduceMotion.matches || typeof details.animate !== 'function') {
          details.open = !details.open;
          details.classList.toggle('is-open', details.open);
          return;
        }

        details.style.overflow = 'hidden';
        if (isClosing || !details.open) {
          open();
        } else if (isExpanding || details.open) {
          shrink();
        }
      });
    }

    function init(scope) {
      var items = (scope || document).querySelectorAll('.de-faq__item');
      Array.prototype.forEach.call(items, setupItem);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["de-flavours"] && !Shopify.designMode) return;
  try {
    
  // Bundled once for the theme, so initialise every section instance found.
  (function () {
    function init(root) {
      if (root.dataset.deFlavoursReady) return;
      root.dataset.deFlavoursReady = '1';

      var track = root.querySelector('.de-flavours__track');
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      // ---- popover focus ------------------------------------------------
      // The popovers open through :target, so nothing moves focus on its own:
      // it stays on the card button behind the scrim, and Tab walks the page
      // under an aria-modal dialog. This moves focus into the panel when one
      // opens, keeps Tab inside it, closes it on Escape, and hands focus back to
      // the card button it was opened from.
      var FOCUSABLE = 'a[href]:not([tabindex="-1"]), button:not([disabled]), summary:not([tabindex="-1"]), input, [tabindex]:not([tabindex="-1"])';
      var lastTrigger = null;
      // Focus goes back only when a popover actually closes. A card tap on
      // mobile records a trigger without opening anything (the first tap only
      // centres the card), and a later jump to #faq must not pull focus here.
      var shownPopover = null;

      function openPopover() {
        var id = window.location.hash.slice(1);
        if (!id) return null;
        var pop = document.getElementById(decodeURIComponent(id));
        return pop && root.contains(pop) && pop.classList.contains('de-flavours__popover') ? pop : null;
      }

      function focusablesIn(pop) {
        // getClientRects rather than offsetParent: the mobile arrows are
        // position:fixed, which leaves offsetParent null while fully visible.
        return Array.prototype.filter.call(pop.querySelectorAll(FOCUSABLE), function (el) {
          return el.getClientRects().length > 0;
        });
      }

      function syncPopover() {
        var pop = openPopover();
        if (pop) {
          shownPopover = pop;
          if (!pop.hasAttribute('tabindex')) pop.setAttribute('tabindex', '-1');
          if (!pop.contains(document.activeElement)) pop.focus({ preventScroll: true });
          return;
        }
        if (!shownPopover) return;
        shownPopover = null;
        if (lastTrigger) {
          var back = lastTrigger;
          lastTrigger = null;
          back.focus();
        }
      }

      root.querySelectorAll('.de-flavours__cta').forEach(function (cta) {
        cta.addEventListener('click', function () { lastTrigger = cta; });
      });

      root.addEventListener('keydown', function (e) {
        var pop = openPopover();
        if (!pop) return;

        if (e.key === 'Escape') {
          var close = pop.querySelector('.de-flavours__close');
          if (close) {
            e.preventDefault();
            close.click();
          }
          return;
        }

        if (e.key !== 'Tab') return;
        var items = focusablesIn(pop);
        if (!items.length) return;
        var first = items[0];
        var last = items[items.length - 1];
        var active = document.activeElement;
        if (e.shiftKey && (active === first || active === pop)) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && (active === last || !pop.contains(active))) {
          e.preventDefault();
          first.focus();
        }
      });

      window.addEventListener('hashchange', syncPopover);
      syncPopover();

      // Hover: play to the midpoint (fully open) and hold there.
      // Mouse-out: jump to the mirrored frame in the reversed half —
      // half + (half - t), i.e. duration - t — then play to the end and hide.
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        var FALLBACK_DURATION = 6; // assumed until metadata lands, so duration is never NaN

        // The clip is a pointer affordance. On touch, pointerenter fires on tap
        // with no pointerleave to follow, so the bar opened and stayed open — and
        // a tap on a card is now how it is brought to the centre of the carousel.
        // So below the breakpoint the card shows its still and nothing else.
        var hoverable = window.matchMedia('(min-width: 991px)');

        // A cold clip cannot be driven. Until data is buffered the mouse-out seek
        // that mirrors into the closing half is dropped on the floor — currentTime
        // reads back 0 with seeking still true — so the whole six seconds played
        // instead of the tail, and the first frame landed late enough to flicker.
        // Only what is on screen is warmed: all 33 elements at once is ~19MB.
        if ('IntersectionObserver' in window) {
          var warmer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              var vid = entry.target.querySelector('video');
              warmer.unobserve(entry.target);
              if (!vid || vid.dataset.deWarm) return;
              // Never while it is mid-animation: load() would reset it.
              if (entry.target.classList.contains('is-playing')) return;
              vid.dataset.deWarm = '1';
              vid.preload = 'auto';
              vid.load();
            });
          }, { rootMargin: '200px' });
          root.querySelectorAll('.de-flavours__media').forEach(function (m) { warmer.observe(m); });
        }

        root.querySelectorAll('.de-flavours__media').forEach(function (media) {
          var v = media.querySelector('video');
          if (!v) return;
          v.muted = true;
          v.playsInline = true;

          var raf = null;
          // Which way the clip is going, rather than a fixed stop time: the goal is
          // recomputed live, so a hover that starts before metadata lands is not stuck
          // with a midpoint derived from FALLBACK_DURATION.
          var phase = null; // 'open' | 'close'
          var leaveTimer = null, leaveTries = 0;

          function dur() {
            return (isFinite(v.duration) && v.duration > 0) ? v.duration : FALLBACK_DURATION;
          }
          function mid() { return dur() / 2; }
          function goal() { return phase === 'close' ? dur() : mid(); }

          function stopWatch() {
            if (raf !== null) cancelAnimationFrame(raf);
            raf = null;
            v.removeEventListener('timeupdate', check);
          }

          function land() {
            stopWatch();
            v.pause();
            if (phase === 'close') {
              v.currentTime = 0;
              media.classList.remove('is-playing');
            } else {
              // Snap to the exact midpoint. A throttled check can fire late, and what
              // should be held is the composed open frame, not wherever it got to.
              v.currentTime = Math.min(goal(), dur());
            }
          }

          function check() {
            // A seek is async; until it settles currentTime still reads the old
            // position, which would otherwise land the clip immediately on re-hover.
            if (v.seeking) return false;
            if (v.currentTime >= goal() - 0.03) {
              land();
              return true;
            }
            return false;
          }

          function watch() {
            stopWatch();
            // timeupdate is driven by the media pipeline rather than the rendering
            // one, so it keeps firing when rAF is throttled — a background tab, low
            // power mode, or a busy page. Without it the clip sails past its stop.
            v.addEventListener('timeupdate', check);
            (function tick() {
              if (check()) return;
              raf = requestAnimationFrame(tick);
            })();
          }

          function play() { var p = v.play(); if (p && p.catch) p.catch(function () {}); }

          function enter() {
            if (!hoverable.matches) return;
            openNow();
          }

          function openNow() {
            // Cancel any leave still waiting to be confirmed.
            if (leaveTimer) { clearTimeout(leaveTimer); leaveTimer = null; }
            leaveTries = 0;

            // Re-entering while it is closing: mirror back into the opening half.
            if (v.currentTime > mid()) v.currentTime = Math.max(0, dur() - v.currentTime);
            media.classList.add('is-playing');
            phase = 'open';
            play();
            watch();
          }

          function closeNow() {
            // half + (half - t) === duration - t
            if (v.currentTime < mid()) v.currentTime = Math.min(dur(), dur() - v.currentTime);
            media.classList.add('is-playing');
            phase = 'close';
            play();
            watch();
          }

          // A stray pointerleave — compositing change, layout shift, a synthetic
          // event — can arrive while the cursor is still on the card, which would
          // send the clip on to the end and read as "it never stopped". So the
          // cursor's real position decides, checked a beat later to let the hover
          // state settle. Discarding the event outright is not safe either: if the
          // check ever reads stale the clip would stay open forever, so it re-checks
          // a bounded number of times. Still hovered after that means it really is.
          function verifyLeave(delay) {
            if (leaveTimer) clearTimeout(leaveTimer);
            leaveTimer = window.setTimeout(function () {
              leaveTimer = null;
              if (!card.matches(':hover')) {
                leaveTries = 0;
                closeNow();
              } else if (++leaveTries < 6) {
                verifyLeave(200);
              } else {
                leaveTries = 0;
              }
            }, delay);
          }

          function leave() {
            if (!hoverable.matches) return;
            verifyLeave(60);
          }

          // Crossing down mid-hover would otherwise strand the clip open, since
          // the pointerleave that would have closed it is now ignored.
          function rest() {
            if (leaveTimer) { clearTimeout(leaveTimer); leaveTimer = null; }
            leaveTries = 0;
            stopWatch();
            v.pause();
            phase = null;
            if (v.currentTime) v.currentTime = 0;
            media.classList.remove('is-playing');
          }

          function onHoverableChange() {
            if (!hoverable.matches) rest();
          }

          // Published so the carousel can drive the same animation from the centre
          // slot on mobile, where there is no pointer to drive it.
          media.deClip = { open: openNow, close: closeNow, rest: rest };
          if (hoverable.addEventListener) hoverable.addEventListener('change', onHoverableChange);
          else if (hoverable.addListener) hoverable.addListener(onHoverableChange);

          v.addEventListener('ended', function () {
            stopWatch();
            v.currentTime = 0;
            media.classList.remove('is-playing');
          });

          var card = media.closest('.de-flavours__card') || media;
          card.addEventListener('pointerenter', enter);
          card.addEventListener('pointerleave', leave);
          card.addEventListener('focusin', enter);
          card.addEventListener('focusout', leave);
        });
      }

      if (!track) return;
      // ---- endless, draggable carousel ---------------------------------
      // The sequence is rendered several times over, so the position can be
      // corrected by exactly one set width at a point where the content is
      // identical. Category filtering hides cards, so every measurement is taken
      // from what is actually visible rather than from the full list.
      var cards = Array.prototype.slice.call(track.querySelectorAll('.de-flavours__item'));
      var passes = Math.max(1, Math.round(cards.length / (parseInt(track.dataset.setSize, 10) || cards.length)));
      var progressBar = root.querySelector('.de-flavours__progress');
      var smoothUntil = 0;
      var settleTimer = null;

      function visibleCards() {
        return cards.filter(function (c) { return c.offsetParent !== null; });
      }
      function step() {
        var v = visibleCards();
        if (!v.length) return 0;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return v[0].getBoundingClientRect().width + gap;
      }
      function setWidth() {
        var v = visibleCards();
        if (!v.length) return 0;
        return step() * (v.length / passes);
      }

      // Writing scrollLeft cancels a smooth scroll in flight, so this is skipped
      // while one is animating and applied once movement settles instead.
      function wrap() {
        var w = setWidth();
        if (!w) return 0;
        var x = track.scrollLeft, target = x;
        while (target < w * 0.5) target += w;
        while (target > w * 1.5) target -= w;
        if (target === x) return 0;
        var prev = track.style.scrollBehavior;
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = target;
        track.style.scrollBehavior = prev;
        return target - x;
      }

      function paintProgress() {
        var w = setWidth();
        if (!w || !progressBar) return;
        var pos = ((track.scrollLeft % w) + w) % w;
        progressBar.style.setProperty('--de-flavours-progress', (pos / w).toFixed(4));
      }

      // Below the breakpoint the comp centres the row and draws the middle card
      // taller. Above it the cards are a plain left-aligned run, so none of this
      // applies.
      var centred = window.matchMedia('(max-width: 990px)');
      var activeCard = null;
      var rowInView = false;

      function clipOf(item) {
        var m = item && item.querySelector('.de-flavours__media');
        return m && m.deClip ? m : null;
      }

      // Below the breakpoint there is no pointer, so the centre slot stands in for
      // it: the card that arrives plays open and holds, and the one it displaced
      // plays out the closing half exactly as a mouse-out would.
      function driveClips(prev, next) {
        if (!centred.matches) return;
        var p = clipOf(prev);
        if (p && p.classList.contains('is-playing')) p.deClip.close();
        if (!rowInView) return;
        var n = clipOf(next);
        if (n) n.deClip.open();
      }

      function nearestToCentre() {
        var vis = visibleCards();
        if (!vis.length) return null;
        var centre = track.getBoundingClientRect().left + track.clientWidth / 2;
        var best = null, bestDist = Infinity;
        for (var i = 0; i < vis.length; i++) {
          var r = vis[i].getBoundingClientRect();
          var d = Math.abs((r.left + r.width / 2) - centre);
          if (d < bestDist) { bestDist = d; best = vis[i]; }
        }
        return best;
      }

      // The flag drives the height change and its easing in CSS; the clip is
      // driven alongside it.
      function paintActive(el) {
        if (!el || el === activeCard) return;
        var prev = activeCard;
        activeCard = el;
        cards.forEach(function (c) {
          c.dataset.featured = c === el ? 'true' : 'false';
        });
        driveClips(prev, el);
      }

      function centreOn(el, smooth) {
        var r = el.getBoundingClientRect();
        var t = track.getBoundingClientRect();
        var left = track.scrollLeft + (r.left - t.left) - (track.clientWidth - r.width) / 2;
        if (smooth !== false) smoothUntil = Date.now() + 700;
        var behavior = smooth === false || reduceMotion.matches ? 'auto' : 'smooth';
        if (track.scrollTo) track.scrollTo({ left: left, behavior: behavior });
        else track.scrollLeft = left;
      }

      function syncActive() {
        if (!centred.matches) {
          if (activeCard) {
            // Back on the pointer's territory: hand the clip back to it, at rest.
            var m = clipOf(activeCard);
            if (m) m.deClip.rest();
            cards.forEach(function (c) { c.dataset.featured = 'false'; });
            activeCard = null;
          }
          return;
        }
        paintActive(nearestToCentre());
      }

      // Nothing should be animating while the row is off screen — and it should
      // pick up where it belongs once the row arrives.
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            rowInView = entry.isIntersecting;
            if (!centred.matches) return;
            var m = clipOf(activeCard);
            if (!m) return;
            if (rowInView) m.deClip.open();
            else m.deClip.rest();
          });
        }, { threshold: 0.5 }).observe(track);
      } else {
        rowInView = true;
      }

      function recentre() {
        var w = setWidth();
        if (!w) return;
        var prev = track.style.scrollBehavior;
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = w;   // start of the middle pass
        track.style.scrollBehavior = prev;
        paintProgress();
        syncActive();
      }

      track.addEventListener('scroll', function () {
        if (Date.now() >= smoothUntil) wrap();
        paintProgress();
        window.clearTimeout(settleTimer);
        settleTimer = window.setTimeout(function () { wrap(); paintProgress(); syncActive(); }, 100);
      }, { passive: true });

      // Pointer dragging. Capture is taken only once the pointer has actually
      // travelled — taking it on pointerdown re-targets the following click and
      // would stop the card's "Jetzt ansehen" link from working.
      var DRAG_THRESHOLD = 5;
      var pressed = false, dragging = false, startX = 0, startScroll = 0, moved = 0, pid = null;

      // The popover's sections are <details> so the mobile comp's accordions work
      // without script. Above the mobile breakpoint the comp shows them all open
      // and not collapsible, and CSS cannot force a <details> open — so it is set
      // here, and released again when the viewport narrows.
      var wide = window.matchMedia('(min-width: 991px)');
      function syncGroups() {
        // Only the shared notices are <details>. The comp shows them open and not
        // collapsible above the breakpoint, and CSS cannot force a <details> open.
        root.querySelectorAll('details.de-flavours__popgroup').forEach(function (d) {
          d.open = wide.matches;
          // Open and fixed on desktop, so the heading is not a control there and
          // should not be a Tab stop that does nothing.
          var sum = d.querySelector('summary');
          if (sum) sum.tabIndex = wide.matches ? -1 : 0;
        });
      }
      syncGroups();
      if (wide.addEventListener) wide.addEventListener('change', syncGroups);
      else if (wide.addListener) wide.addListener(syncGroups);

      // Above the breakpoint the heading is not a control, so it should not
      // respond to clicks or take focus as one.
      root.querySelectorAll('.de-flavours__popheading').forEach(function (sum) {
        sum.addEventListener('click', function (e) {
          if (wide.matches) e.preventDefault();
        });
      });

      track.addEventListener('dragstart', function (e) { e.preventDefault(); });

      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch' || e.button !== 0) return;
        pressed = true; dragging = false; moved = 0; pid = e.pointerId;
        startX = e.clientX; startScroll = track.scrollLeft;
      });
      track.addEventListener('pointermove', function (e) {
        if (!pressed || e.pointerId !== pid) return;
        var dx = e.clientX - startX;
        moved = Math.max(moved, Math.abs(dx));
        if (!dragging) {
          if (moved <= DRAG_THRESHOLD) return;
          dragging = true;
          track.setAttribute('data-dragging', '');
          try { track.setPointerCapture(pid); } catch (err) {}
        }
        track.scrollLeft = startScroll - dx;
        var shifted = wrap();
        if (shifted) startScroll += shifted;
      });
      function endDrag() {
        if (!pressed) return;
        pressed = false;
        if (!dragging) { pid = null; return; }
        dragging = false;
        track.removeAttribute('data-dragging');
        try { track.releasePointerCapture(pid); } catch (err) {}
        pid = null;
        if (centred.matches) {
          var el = nearestToCentre();
          if (el) { centreOn(el); paintActive(el); }
        }
      }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);

      // A drag that travelled must not also open a product popover.
      track.addEventListener('click', function (e) {
        if (moved > DRAG_THRESHOLD) { e.preventDefault(); e.stopPropagation(); }
        moved = 0;
      }, true);

      // Same affordance as the social reel: below the breakpoint a tap on a side
      // card only brings it to the centre. The CTA hit area spans the whole card,
      // so that first tap has to suppress the popover it would otherwise open —
      // once the card is centred, the next tap opens it.
      cards.forEach(function (el) {
        el.addEventListener('click', function (e) {
          if (!centred.matches || el === activeCard) return;
          e.preventDefault();
          centreOn(el);
          paintActive(el);
        });
      });

      root.querySelectorAll('.de-flavours__arrow[data-nav]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var d = step();
          if (!d) return;
          smoothUntil = Date.now() + 700;
          track.scrollBy({ left: (btn.dataset.nav === 'next' ? 1 : -1) * d, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
        });
      });

      // Changing category changes how many cards are visible, so the set width
      // changes with it — start the filtered row from its own middle pass.
      root.querySelectorAll('.de-flavours__radio').forEach(function (radio) {
        radio.addEventListener('change', recentre);
      });

      // A radio cannot be unchecked by clicking it again, so a second click on
      // the tab that is already active is caught before the label re-checks it
      // and redirected to the hidden "all" radio instead. Without JS the filter
      // still selects — it just cannot be cleared.
      var allRadio = root.querySelector('.de-flavours__radio[data-cat-all]');
      root.querySelectorAll('.de-flavours__tab[for]').forEach(function (tab) {
        tab.addEventListener('click', function (e) {
          var radio = tab.control || document.getElementById(tab.htmlFor);
          if (!allRadio || !radio || !radio.checked) return;
          e.preventDefault();
          allRadio.checked = true;
          recentre();
        });
      });



      recentre();
      window.addEventListener('resize', recentre);
      if (centred.addEventListener) centred.addEventListener('change', recentre);
      else if (centred.addListener) centred.addListener(recentre);
    }

    function boot() { document.querySelectorAll('.de-flavours').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["de-header"]) return;
  try {
    
  (function () {
    function init(header) {
      if (header.dataset.deHeaderScroll) return;
      header.dataset.deHeaderScroll = '1';

      var lastY = window.scrollY || 0;
      var ticking = false;
      var downAccum = 0, upAccum = 0;
      var HIDE_AFTER = 100; // must scroll down this far before it hides
      var SHOW_AFTER = 10;  // but comes back quickly on the way up

      function update() {
        ticking = false;
        var y = window.scrollY || 0;
        var h = header.offsetHeight || 0;
        var delta = y - lastY;
        lastY = y;

        // While the drawer is open the header *is* the menu — hiding it would
        // slide the open drawer off the top of the screen.
        if (header.classList.contains('is-open')) {
          header.classList.remove('is-hidden');
          downAccum = upAccum = 0;
          return;
        }

        // Near the top it is always visible, and the counters reset so the
        // next downward run has to earn the full distance again.
        if (y <= h) {
          header.classList.remove('is-hidden');
          downAccum = upAccum = 0;
          return;
        }

        if (delta > 0) {
          downAccum += delta;
          upAccum = 0;
          if (downAccum > HIDE_AFTER) header.classList.add('is-hidden');
        } else if (delta < 0) {
          upAccum -= delta;
          downAccum = 0;
          if (upAccum > SHOW_AFTER) header.classList.remove('is-hidden');
        }
      }

      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      }, { passive: true });

      // A drawer or in-page jump should not leave it hidden
      document.addEventListener('focusin', function (e) {
        if (header.contains(e.target)) header.classList.remove('is-hidden');
      });
    }

    function boot() { document.querySelectorAll('.de-header').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["de-hero"] && !Shopify.designMode) return;
  try {
    
  // The clip unwinds from its start angle to level as it plays. The angle is read from
  // currentTime every frame rather than run as a fixed CSS animation, so a stall while
  // buffering holds the rotation with the picture instead of drifting ahead of it.
  (function () {
    // Used only until metadata lands, so the first frames never divide by NaN.
    var FALLBACK_DURATION = 8;

    function setup(video) {
      var section = video.closest('.de-hero');
      if (!section) return;

      var start = parseFloat(section.dataset.videoRotation);
      if (!isFinite(start)) start = 0;

      function angle(deg) {
        section.style.setProperty('--de-hero-video-rotation', deg + 'deg');
      }

      // Autoplay is muted and decorative, so it is allowed everywhere — but a stated
      // preference for reduced motion gets the settled frame, not a tipped-over bar.
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        video.autoplay = false;
        video.pause();
        angle(0);
        return;
      }

      var frame = null;

      function duration() {
        return isFinite(video.duration) && video.duration > 0 ? video.duration : FALLBACK_DURATION;
      }

      // Cubic ease-in-out, applied to progress rather than as a CSS transition: a
      // transition would chase each per-frame value and lag behind the picture.
      function ease(t) {
        return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
      }

      function tick() {
        var progress = Math.min(1, Math.max(0, video.currentTime / duration()));
        angle(start * (1 - ease(progress)));

        if (progress < 1 && !video.ended && !video.paused) {
          frame = requestAnimationFrame(tick);
        } else {
          frame = null;
          if (video.ended || progress >= 1) angle(0);
        }
      }

      function run() {
        if (frame === null) frame = requestAnimationFrame(tick);
      }

      video.addEventListener('play', run);
      video.addEventListener('seeked', tick);
      video.addEventListener('ended', function () {
        if (frame !== null) cancelAnimationFrame(frame);
        frame = null;
        angle(0);
      });

      // Autoplay may already have begun before this script ran.
      if (!video.paused) run();
    }

    document.querySelectorAll('.de-hero__video').forEach(setup);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["de-newsletter"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // The hidden iframe's load is the only signal Brevo has answered, and it is
    // cross-origin, so whether the address was accepted is unreadable. This covers
    // the one detectable failure: the request never completing at all.
    var SETTLE_TIMEOUT = 12000;

    // A beat between the check landing on the button and the input fading out to
    // the confirmation, so the two reads do not collide. A pause rather than a
    // tween, so it stands under prefers-reduced-motion; the fade itself does not.
    var HOLD_BEFORE_SWAP = 600;

    function initNewsletter(root) {
      var scope = root || document;
      var forms = scope.querySelectorAll('.de-newsletter__form');

      forms.forEach(function (form) {
        if (form.dataset.deNewsletterReady === 'true') return;
        form.dataset.deNewsletterReady = 'true';

        var iframe = document.querySelector('iframe[name="' + form.getAttribute('target') + '"]');
        if (!iframe) return;

        var submit = form.querySelector('.de-newsletter__submit');
        // Only ever read, never set: the tick has to be the visitor's own.
        var consent = form.querySelector('[data-de-newsletter-consent]');
        // The confirmation shares the input's slot inside the form; the error line
        // is a sibling of the form, so it has to be looked up a level higher.
        var successEl = form.querySelector('[data-de-newsletter-success]');
        var content = form.closest('.de-newsletter__content') || form.parentElement;
        var errorEl = content.querySelector('[data-de-newsletter-error]');
        var liveStatus = content.querySelector('[data-de-newsletter-live="status"]');
        var liveAlert = content.querySelector('[data-de-newsletter-live="alert"]');
        var timer;

        // Clearing first means the same message twice in a row still counts as a
        // change and is read again.
        function announce(region, text) {
          if (liveStatus) liveStatus.textContent = '';
          if (liveAlert) liveAlert.textContent = '';
          if (!region || !text) return;
          window.setTimeout(function () { region.textContent = text; }, 50);
        }

        function show(el, visible) {
          if (el) el.hidden = !visible;
        }

        function consentGiven() {
          return !consent || consent.checked;
        }

        function setState(state) {
          if (!submit) return;
          submit.dataset.state = state;

          if (state === 'idle') {
            submit.disabled = !consentGiven();
            return;
          }

          // Deferred a tick: disabling a submit button inside its own submit
          // handler cancels the submission in some engines.
          setTimeout(function () {
            submit.disabled = true;
          }, 0);
        }

        // Disabled from the start until the box is ticked. The markup leaves the
        // button enabled so the form still works without this script; required on
        // the checkbox holds the line there.
        setState('idle');

        if (consent) {
          consent.addEventListener('change', function () {
            // While in flight or sent, the disabled state belongs to the request,
            // not the checkbox.
            if (submit && submit.dataset.state === 'idle') setState('idle');
          });
        }

        // Only fires once the email and the consent pass native validation.
        form.addEventListener('submit', function () {
          form.dataset.deNewsletterSubmitted = 'true';
          show(errorEl, false);
          announce(null);
          setState('loading');

          clearTimeout(timer);
          timer = setTimeout(function () {
            if (!submit || submit.dataset.state !== 'loading') return;
            // Marked, not cleared, so a reply arriving after the deadline can
            // still retract the error below.
            form.dataset.deNewsletterSubmitted = 'timeout';
            show(errorEl, true);
            announce(liveAlert, errorEl && errorEl.textContent.trim());
            setState('idle');
          }, SETTLE_TIMEOUT);
        });

        iframe.addEventListener('load', function () {
          var sent = form.dataset.deNewsletterSubmitted;
          // Neither value is set on the iframe's initial about:blank load.
          if (sent !== 'true' && sent !== 'timeout') return;
          clearTimeout(timer);
          show(errorEl, false);
          setState('done');

          window.setTimeout(function () {
            show(successEl, true);
            announce(liveStatus, successEl && successEl.textContent.trim());
            // Two frames: the element has to be laid out at opacity 0 before the
            // class that takes it to 1 can transition from anything.
            requestAnimationFrame(function () {
              requestAnimationFrame(function () {
                form.dataset.state = 'done';
              });
            });
          }, HOLD_BEFORE_SWAP);
        });
      });
    }

    function onReady(fn) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', fn);
      } else {
        fn();
      }
    }

    onReady(function () {
      initNewsletter(document);
    });

    document.addEventListener('shopify:section:load', function (event) {
      initNewsletter(event.target);
    });
  })();

  // The clip just loops. It starts when the section arrives rather than on load,
  // since it sits below the fold, and pauses again when it leaves — an endless
  // clip left running off-screen decodes for the whole visit for nothing.
  (function () {
    // Where the animation settles, used only as the still for reduced motion.
    // Frame 0 is empty, so there is nothing to look at until the clip has run.
    var HOLD_AT = 2;

    function init(root) {
      var scope = root || document;
      Array.prototype.forEach.call(scope.querySelectorAll('.de-newsletter__video'), function (video) {
        if (video.dataset.deClipReady === 'true') return;
        video.dataset.deClipReady = 'true';

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          // A composed frame rather than an empty box, arrived at without motion.
          if (video.readyState >= 2) {
            video.currentTime = HOLD_AT;
          } else {
            video.addEventListener('canplay', function ready() {
              video.removeEventListener('canplay', ready);
              video.currentTime = HOLD_AT;
            });
            video.preload = 'auto';
            video.load();
          }
          return;
        }

        function play() {
          var started = video.play();
          if (started && started.catch) started.catch(function () {});
        }

        if (!('IntersectionObserver' in window)) {
          play();
          return;
        }

        new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) play();
              else video.pause();
            });
          },
          { threshold: 0.25 }
        ).observe(video);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); });
    } else {
      init(document);
    }
    document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["de-social"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.deSocialReady) return;
      root.dataset.deSocialReady = '1';

      var track = root.querySelector('.de-social__track');
      if (!track) return;
      var cards = Array.prototype.slice.call(track.querySelectorAll('.de-social__item'));
      if (!cards.length) return;

      // The same sequence rendered several times over. `setSize` is how many cards
      // make one pass of it.
      var setSize = parseInt(track.dataset.setSize, 10) || cards.length;
      var progress = root.querySelector('.de-social__progress');
      var soundOn = false;
      var inView = false;
      var activeCard = null;
      var settle = null;
      var smoothUntil = 0;   // a programmatic smooth scroll is animating until this time
      // Reduced motion: no autoplay, no advancing to the next clip when one ends,
      // and no smooth scrolling. The clips stay on their poster frame; the sound
      // button still starts one, so a clip can be watched on request.
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      function scrollBehavior() { return reduceMotion.matches ? 'auto' : 'smooth'; }

      function videoOf(el) { return el.querySelector('video'); }

      function step() {
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return cards[0].getBoundingClientRect().width + gap;
      }
      function setWidth() { return step() * setSize; }

      // Keep the scroll position inside the middle pass. Correcting by exactly one
      // set width lands on identical content, so nothing appears to move — unlike
      // shuffling individual cards, which visibly flickers.
      // Returns how far the position was moved, so a drag in progress can rebase
      // against it and carry on without a jolt.
      function wrap() {
        var w = setWidth();
        if (!w) return 0;
        var x = track.scrollLeft;
        var target = x;
        while (target < w * 0.5) target += w;
        while (target > w * 1.5) target -= w;
        if (target === x) return 0;
        var prev = track.style.scrollBehavior;
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = target;
        track.style.scrollBehavior = prev;
        return target - x;
      }

      function nearestToCentre() {
        var centre = track.getBoundingClientRect().left + track.clientWidth / 2;
        var best = null, bestDist = Infinity;
        for (var i = 0; i < cards.length; i++) {
          var r = cards[i].getBoundingClientRect();
          var d = Math.abs((r.left + r.width / 2) - centre);
          if (d < bestDist) { bestDist = d; best = cards[i]; }
        }
        return best;
      }

      // A copy (see the markup) is hidden and out of the tab order unless it is
      // the featured card, whose controls have to stay reachable.
      function exposeCopy(card, on) {
        if (!card.hasAttribute('data-copy')) return;
        if (on) card.removeAttribute('aria-hidden');
        else card.setAttribute('aria-hidden', 'true');
        card.querySelectorAll('a, button').forEach(function (control) {
          if (on) control.removeAttribute('tabindex');
          else control.setAttribute('tabindex', '-1');
        });
      }

      function paint(el) {
        if (el === activeCard) return;
        activeCard = el;
        var slot = parseInt(el.dataset.slot, 10) || 0;
        cards.forEach(function (card) {
          var on = card === el;
          card.dataset.featured = on ? 'true' : 'false';
          exposeCopy(card, on);
          var v = videoOf(card);
          if (!v) return;
          if (on) {
            v.muted = !soundOn;
          } else {
            v.pause();
            if (v.currentTime) v.currentTime = 0;
            v.muted = true;
          }
          var mb = card.querySelector('[data-mute]');
          if (mb) mb.setAttribute('aria-pressed', String(v.muted));
        });
        if (progress && setSize > 1) {
          progress.style.setProperty('--de-social-progress', slot / (setSize - 1));
        }
        playActive();
      }

      function playActive() {
        if (!inView || !activeCard || reduceMotion.matches) return;
        var v = videoOf(activeCard);
        if (!v) return;
        var p = v.play();
        if (p && p.catch) p.catch(function () {
          v.muted = true; soundOn = false;
          var r = v.play(); if (r && r.catch) r.catch(function () {});
        });
      }

      function centreOn(el, smooth) {
        var r = el.getBoundingClientRect();
        var t = track.getBoundingClientRect();
        var left = track.scrollLeft + (r.left - t.left) - (track.clientWidth - r.width) / 2;
        if (smooth !== false) smoothUntil = Date.now() + 700;
        if (track.scrollTo) track.scrollTo({ left: left, behavior: smooth === false ? 'auto' : scrollBehavior() });
        else track.scrollLeft = left;
      }

      function stepBy(dir) {
        smoothUntil = Date.now() + 700;
        track.scrollBy({ left: dir * step(), behavior: scrollBehavior() });
      }

      track.addEventListener('scroll', function () {
        // Wrapping writes scrollLeft, which cancels any smooth scroll in flight —
        // that is what left an arrow press part-completed. So it is skipped while
        // one is animating, and applied once movement settles instead. Dragging
        // and momentum have no animation to break, so they wrap immediately.
        if (Date.now() >= smoothUntil) wrap();
        window.clearTimeout(settle);
        settle = window.setTimeout(function () {
          wrap();
          var el = nearestToCentre();
          if (el) paint(el);
        }, 100);
      }, { passive: true });

      // --- pointer dragging (touch scrolls natively already) ---------------
      // Capture is deliberately NOT taken on pointerdown. Capturing there
      // re-targets the following click to the track, so a plain click on a card
      // never reaches the card's own handler — which is what stopped clicking
      // from working. It is taken only once the pointer has actually travelled.
      var DRAG_THRESHOLD = 5;
      var pressed = false, dragging = false;
      var startX = 0, startScroll = 0, moved = 0, pointerId = null;

      // Belt and braces for the native image drag: some engines ignore the CSS.
      track.addEventListener('dragstart', function (e) { e.preventDefault(); });

      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch' || e.button !== 0) return;
        pressed = true; dragging = false; moved = 0;
        pointerId = e.pointerId;
        startX = e.clientX;
        startScroll = track.scrollLeft;
      });

      track.addEventListener('pointermove', function (e) {
        if (!pressed || e.pointerId !== pointerId) return;
        var dx = e.clientX - startX;
        moved = Math.max(moved, Math.abs(dx));

        if (!dragging) {
          if (moved <= DRAG_THRESHOLD) return;   // still just a press
          dragging = true;
          track.setAttribute('data-dragging', '');
          try { track.setPointerCapture(pointerId); } catch (err) {}
        }

        track.scrollLeft = startScroll - dx;
        // Rebase if the position wrapped, so the card stays under the cursor.
        var shifted = wrap();
        if (shifted) startScroll += shifted;
      });

      function endDrag(e) {
        if (!pressed) return;
        pressed = false;
        if (!dragging) { pointerId = null; return; }   // a click, not a drag
        dragging = false;
        track.removeAttribute('data-dragging');
        try { track.releasePointerCapture(pointerId); } catch (err) {}
        pointerId = null;
        var el = nearestToCentre();
        if (el) { centreOn(el); paint(el); }
      }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);

      // A drag that travelled should not also register as a click on the card.
      track.addEventListener('click', function (e) {
        if (moved > DRAG_THRESHOLD) { e.preventDefault(); e.stopPropagation(); }
        moved = 0;
      }, true);

      root.querySelectorAll('.de-social__arrow[data-nav]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          stepBy(btn.dataset.nav === 'next' ? 1 : -1);
        });
      });

      cards.forEach(function (el) {
        el.addEventListener('click', function (e) {
          if (e.target.closest('.de-social__buy, [data-mute]')) return;
          if (el === activeCard) return;
          centreOn(el);
        });

        var btn = el.querySelector('[data-mute]');
        var v = videoOf(el);
        if (btn && v) {
          btn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            soundOn = v.muted;
            v.muted = !soundOn;
            btn.setAttribute('aria-pressed', String(v.muted));
            var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
          });
        }
        if (v) {
          // No advancing while keyboard focus is in the reel either: moving on would
          // re-hide the card under the focused control.
          v.addEventListener('ended', function () {
            if (el !== activeCard || reduceMotion.matches) return;
            if (track.contains(document.activeElement)) return;
            stepBy(1);
          });
        }
      });

      function start() {
        // Begin on the first card of the middle pass, so there is a full sequence
        // available in both directions from the outset.
        var first = cards[setSize] || cards[0];
        centreOn(first, false);
        paint(first);
      }
      start();

      if ('ResizeObserver' in window) {
        new ResizeObserver(function () {
          if (!dragging && activeCard) centreOn(activeCard, false);
        }).observe(track);
      }
      window.addEventListener('load', start);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(start);

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            inView = entry.isIntersecting;
            if (inView) playActive();
            else if (activeCard) { var v = videoOf(activeCard); if (v) v.pause(); }
          });
        }, { threshold: 0.35 }).observe(root);
      } else {
        inView = true;
        playActive();
      }
    }

    function boot() { document.querySelectorAll('.de-social').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
